// VideoGrid.tsx
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Modal,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useState } from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import "./Video.scss";
import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { useNavigate } from "react-router-dom";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import Menus from "../../Components/Menu/Menu";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import UserProfileSection from "../../Components/UserProfileSection/UserProfileSection";

const VideoGrid: React.FC = () => {
  const isUCAT =
    window.location.hostname.split(".")[0]?.includes("ucat") ||
    window.location.hostname.split(".")[0] === "192";

  const [openvideo, setOpenvideo] = useState(false);

  const handleOpen = (index: number) => {
    setCurrentIndex(index); // set the video to play
    setOpenvideo(true); // open modal
  };
  const handleClosevideo = () => setOpenvideo(false);
  const videoList = [
    {
      id: 1,
      title: `${isUCAT ? "UCAT" : "GATE"} EXAM Sample Quick Walkthrough - Abstract Reasoning - WA 2025`,
      time: "11:03",
      url: "https://www.youtube.com/embed/_6nPzWtZQKs?si=-2BuDfDeBQ6DIo5N",
    },
    {
      id: 2,
      title: `${isUCAT ? "UCAT" : "GATE"} EXAM Sample Full Walkthrough - Reading Comprehension - WA 2025`,
      time: "34:54",
      url: "https://www.youtube.com/embed/MuBpPJ7Mgns?si=1kR0POSP828pVmmk",
    },
    {
      id: 3,
      title: `${isUCAT ? "UCAT" : "GATE"} EXAM Sample Full Walkthrough - Writing - WA 2025`,
      time: "23:26",
      url: "https://www.youtube.com/embed/Eg0Jo5tDtNE?si=migH1w7N_zdAhqj-",
    },
    {
      id: 4,
      title: `${isUCAT ? "UCAT" : "GATE"} EXAM Sample Full Walkthrough - Quantitative Reasoning - WA 2025`,
      time: "52:53",
      url: "https://www.youtube.com/embed/nKkoTJrcMzY?si=XnCZCRBKtVw9aYoS",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const currentVideo = videoList[currentIndex];

  const handleNextvideo = () => {
    setCurrentIndex((prev) => (prev + 1) % videoList.length);
  };

  const handlePrevideo = () => {
    setCurrentIndex((prev) => (prev - 1 + videoList.length) % videoList.length);
  };

  const handleVideoSelect = (index: number) => {
    setCurrentIndex(index);
  };
  const extractVideoId = (url: string) => {
    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=))([\w-]+)/
    );
    return match ? match[1] : "";
  };

  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const filteredVideos = videoList.filter((video) =>
    video.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const dispatch = useAppDispatch();
  const nav = useNavigate();

  React.useEffect(() => {
    dispatch(listUser());
  }, [dispatch]);
  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];
  return (
    <div className="ViedoStudentAlingment">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div className="DashboardStudent" style={{ fontWeight: "700" }}>
            Video Tutorials
          </div>
          <div className="StudentPractice" style={{ fontSize: "14px" }}>
            Explore walkthroughs, teaching clips, and revision tips.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search videos..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{
              borderRadius: "8px",
              width: "25%",
              backgroundColor: "#fff",
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />{" "}
          <UserProfileSection />
        </div>
      </div>

      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              sx={{
                "& .MuiTab-root": {
                  "&.Mui-selected": {
                    background: "none !important",
                    color: "#009dff !important",
                  },
                },
                "& .MuiTabs-indicator": {
                  margin: "9px 0px",
                },
              }}
              aria-label="lab API tabs example"
            >
              <Tab
                label="All"
                value="1"
                sx={{ textTransform: "capitalize", fontSize: "14px" }}
              />
              <Tab
                label={isUCAT ? "UCAT Walkthroughs" : "GATE Walkthroughs"}
                value="2"
                sx={{ textTransform: "capitalize", fontSize: "14px" }}
              />
              <Tab
                label="Short Lessons"
                value="3"
                sx={{ textTransform: "capitalize", fontSize: "14px" }}
              />
              <Tab
                label="Student Picks"
                value="4"
                sx={{ textTransform: "capitalize", fontSize: "14px" }}
              />
            </TabList>
          </Box>
          <TabPanel sx={{ padding: "24px 0px" }} value="1">
            <Grid container spacing={3}>
              {filteredVideos.map((video, index) => (
                <Grid key={video.id} item xs={12} sm={12} md={6} lg={3}>
                  <Box
                    sx={{
                      boxShadow: "0 0px 5px rgba(0, 0, 0, 0.1)",
                      // height: "20rem",
                      borderRadius: "10px",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      "&:hover": {
                        boxShadow: "0 4px 4px rgba(0,0,0,0.18)",
                      },
                    }}
                  >
                    <Card
                      sx={{
                        cursor: "pointer",
                        borderRadius: "10px 10px 0px  0px",
                      }}
                      onClick={() => handleOpen(index)} // pass index here
                    >
                      <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
                        {" "}
                        {/* 16:9 Aspect Ratio */}
                        <CardMedia
                          component="img"
                          image={`https://img.youtube.com/vi/${extractVideoId(
                            video.url
                          )}/0.jpg`}
                          alt={video.title}
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover", // THIS REMOVES BLACK BARS
                          }}
                        />
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 8,
                            right: 8,
                            background: "#000000BF",
                            color: "white",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <AccessTimeIcon />
                          <span>{video.time}</span>
                        </Box>
                      </Box>
                    </Card>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      className="viedotitle"
                    >
                      {video.title}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </TabPanel>
          <TabPanel sx={{ padding: "24px 0px" }} value="2">
            <Grid container spacing={3}>
              {filteredVideos.map((video, index) => (
                <Grid key={video.id} item xs={12} sm={12} md={6} lg={3}>
                  <Box
                    sx={{
                      boxShadow: "0 0px 5px rgba(0, 0, 0, 0.1)",
                      // height: "20rem",
                      borderRadius: "10px",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      "&:hover": {
                        boxShadow: "0 4px 4px rgba(0,0,0,0.18)",
                      },
                    }}
                  >
                    <Card
                      sx={{
                        cursor: "pointer",
                        borderRadius: "10px 10px 0px  0px",
                      }}
                      onClick={() => handleOpen(index)} // pass index here
                    >
                      <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
                        {" "}
                        {/* 16:9 Aspect Ratio */}
                        <CardMedia
                          component="img"
                          image={`https://img.youtube.com/vi/${extractVideoId(
                            video.url
                          )}/0.jpg`}
                          alt={video.title}
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover", // THIS REMOVES BLACK BARS
                          }}
                        />
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 8,
                            right: 8,
                            background: "#000000BF",
                            color: "white",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <AccessTimeIcon />
                          <span>{video.time}</span>
                        </Box>
                      </Box>
                    </Card>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      className="viedotitle"
                    >
                      {video.title}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </TabPanel>
          <TabPanel value="3">
            <div
              style={{
                color: "#6b7280",
                padding: "4rem",
                fontSize: "16px",
                textAlign: "center",
              }}
            >
              No videos found matching your criteria.
            </div>
          </TabPanel>
          <TabPanel value="4">
            <div
              style={{
                color: "#6b7280",
                padding: "4rem",
                fontSize: "16px",
                textAlign: "center",
              }}
            >
              No videos found matching your criteria.
            </div>
          </TabPanel>{" "}
        </TabContext>
      </Box>

      <Modal open={openvideo}>
        {/* Video Area with Previews */}
        <>
          <Box sx={{ width: "100%", position: "relative" }}>
            <IconButton
              sx={{
                position: "absolute",
                top: 6,
                right: 38,
                m: 1, // optional: adds margin from edges
                color: "#FFFFFF",
                zIndex: 2,
                backgroundColor: "gray",
              }}
              onClick={handleClosevideo}
            >
              <CloseIcon
                sx={{ fontSize: "20px", color: "white", fontWeight: 600 }}
              />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              width: "100%",
              height: "100%",
              mb: 2,
            }}
          >
            {/* Left Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handlePrevideo}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>

            {/* Center Main Video */}
            <Box sx={{ width: "80%" }}>
              <Box
                component="iframe"
                width="100%"
                src={`${currentVideo.url}?autoplay=1`}
                title={currentVideo.title}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                sx={{ borderRadius: "20px", height: "60rem" }}
              />
            </Box>

            {/* Right Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handleNextvideo}
              >
                <ArrowForwardIosIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>
          </Box>
        </>
      </Modal>
    </div>
  );
};

export default VideoGrid;
